import { memo, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { debounce, ErrorAlert, PageLoadingSpinner, Search } from 'ui_kit_qmd'
import { useDispatch } from 'react-redux'
import { useSelector } from 'store/hooks/useSelector'
import { ChartPageItem } from '../../components/ChartPageItem/ChartPageItem'
import './Charts.scss'
import { getStateByAbbreviation, getTabId, parseTimeZone } from '../../utils/common'
import errorIcon from '../../images/common/error-icon.svg'
import { clearChartPatientList, setChartError } from '../../store/charts/ChartsActions'
import { getChartPatientsList } from '../../store/charts/ChartsThunk'
import { SEARCH_VALUE_MIN_LENGTH } from './Constants'
import EmptyState from './EmptyState'
import { clearCancelledVisitId } from '../../store/visits/VisitsActions'
import { PageLayout } from 'components/page-layouts/PageLayout'

const errorAlertStyle = {
  marginLeft: 'auto',
  marginRight: 'auto',
  top: 0,
  zIndex: 9999,
  position: 'absolute',
  left: 0,
  right: 0,
}
const errorAlertContainerStyle = { width: 550 }

const Charts = memo(() => {
  const tabId = getTabId()
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const chartPatientsList = useSelector((state) => state.chartsReducer.chartPatientsList)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const lastListIncrease = useSelector((state) => state.chartsReducer.lastListIncrease)
  const isLoggedIn = useSelector((state) => state.auth.accessToken)
  const loading = useSelector((state) => state.chartsReducer.loading)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const error = useSelector((state) => state.chartsReducer.error)
  const dispatch = useDispatch()
  const [offSet, setOffSet] = useState(0)
  const [sortCondition] = useState('')
  const [isFirstRender, setIsFirstRender] = useState(true)
  const [count] = useState(20)
  const [chartsSearchInputValue, setChartsSearchInputValue] = useState('')
  const [resetSearch, setResetSearch] = useState(false)
  const profile = useSelector((state) => state.waitingRoomReducer.providerProfile)
  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
  const timeZone = parseTimeZone(profile.TimeZone)

  const onChangeSearchInputValue = useCallback(
    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    (value) => {
      const searchValue = value.trim()

      if (searchValue?.length >= SEARCH_VALUE_MIN_LENGTH) {
        setOffSet(0)
        dispatch(clearChartPatientList())
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        dispatch(getChartPatientsList(0, count, searchValue, true))
      } else if (chartsSearchInputValue?.length && searchValue === '') {
        setOffSet(0)
        dispatch(clearChartPatientList())
      }

      setChartsSearchInputValue(searchValue)
    },
    [chartsSearchInputValue?.length, count, dispatch, sortCondition],
  )

  const onSearch = debounce(onChangeSearchInputValue, 500)

  useEffect(() => {
    window.onpopstate = null
  }, [])

  useEffect(() => {
    if (resetSearch) {
      setResetSearch(false)
    }
  }, [resetSearch])

  const listInnerRef = useRef(null)

  useLayoutEffect(() => {
    dispatch(clearChartPatientList())
    setOffSet(0)
  }, [])

  useEffect(() => {
    dispatch(clearChartPatientList())
    dispatch(clearCancelledVisitId())
  }, [])

  useEffect(() => {
    setIsFirstRender(false)
    if (lastListIncrease === 20 && !loading && !isFirstRender) {
      // @ts-expect-error TS2365 -- MIGRATION: not approved, fix when encountered
      if (chartsSearchInputValue.trim() >= SEARCH_VALUE_MIN_LENGTH) {
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        dispatch(getChartPatientsList(offSet, count, chartsSearchInputValue))
      }
    }
  }, [offSet])

  useEffect(() => {
    if (!isFirstRender) {
      setOffSet(0)
      dispatch(clearChartPatientList())
      // @ts-expect-error TS2365 -- MIGRATION: not approved, fix when encountered
      if (chartsSearchInputValue.trim() >= SEARCH_VALUE_MIN_LENGTH) {
        // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
        dispatch(getChartPatientsList(0, count, chartsSearchInputValue))
      }
      setIsFirstRender(false)
    }
  }, [sortCondition])

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        dispatch(setChartError({ errorMsg: '', tabId }))
      }, 3500)
    }
  }, [error])

  const onHandleClearSearch = useCallback(() => {
    setChartsSearchInputValue('')
    setResetSearch(true)
    dispatch(clearChartPatientList())
  }, [dispatch])

  const onScroll = () => {
    if (listInnerRef?.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current
      if (scrollHeight - (scrollTop + clientHeight) < 20) {
        if (!loading && chartPatientsList?.length > offSet) {
          // @ts-expect-error TS2365 -- MIGRATION: not approved, fix when encountered
          if (!lastListIncrease < 20) {
            setOffSet((prev) => prev + 20)
          }
        }
      }
    }
  }

  const chartsBodyTableStyle = useMemo(
    () => ({
      minHeight: chartPatientsList?.length > 0 ? 175 : 76,
      height: chartPatientsList?.length ? 'auto' : 77,
    }),
    [chartPatientsList?.length],
  )

  // @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
  const reloadSection = () => {
    setOffSet(0)
    dispatch(clearChartPatientList())
    if (chartsSearchInputValue?.trim()?.length >= SEARCH_VALUE_MIN_LENGTH) {
      // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
      dispatch(getChartPatientsList(0, count, chartsSearchInputValue))
    }
  }

  return (
    <div>
      {error ?
        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
        <div style={errorAlertStyle}>
          <ErrorAlert styleContainer={errorAlertContainerStyle} errorText={error} errorImg={errorIcon} imgAlt='Error' />
        </div>
      : null}

      {loading ?
        <PageLoadingSpinner />
      : null}

      <PageLayout>
        <div className='chart-room-container'>
          <div className='chart-header-container'>
            <div className='chart-room-title'>Patient charts</div>
            <Search
              onInputChange={onSearch}
              isWithoutSearchDropdown
              searchToolContainerClassName='search-tool-container-class-name'
              forceUpdate={resetSearch}
            />
          </div>
          <div className='waiting-room-table-with-toolbox-container charts-table-with-toolbox-container'>
            <div className='charts-body-table' onScroll={onScroll} ref={listInnerRef} style={chartsBodyTableStyle}>
              {chartPatientsList?.length && isLoggedIn ?
                chartPatientsList.map(
                  (
                    {
                      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                      PatientId,
                      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                      FirstName,
                      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                      LastName,
                      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                      Email,
                      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                      BirthDate,
                      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                      Gender,
                      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                      StateCode,
                      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                      ImageUrl,
                      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                      PhoneNumber,
                      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                      LastSeenDateTime,
                      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                      MedicalRecordNumber,
                      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                      IsActive,
                      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                      RestrictionStatus,
                      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                      DrugScreen,
                      // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
                      IdentityVerification,
                    },
                    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
                    i,
                  ) => (
                    <ChartPageItem
                      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                      ImageUrl={ImageUrl}
                      loading={loading}
                      ItemId={PatientId}
                      FirstName={FirstName}
                      LastName={LastName}
                      Gender={Gender}
                      BirthDate={BirthDate}
                      Prefix={PhoneNumber.Prefix}
                      PhoneNumber={PhoneNumber.Number}
                      Email={Email}
                      DrugScreen={DrugScreen}
                      patientState={StateCode ? getStateByAbbreviation(StateCode.toUpperCase()) : '--'}
                      MRN={MedicalRecordNumber}
                      LastSeenDateTime={LastSeenDateTime}
                      isLastElem={i === chartPatientsList.length - 1}
                      IsActive={IsActive}
                      RestrictionStatus={RestrictionStatus}
                      key={PatientId}
                      timeZone={timeZone}
                      IdentityVerification={IdentityVerification}
                    />
                  ),
                )
              : <EmptyState
                  chartsSearchInputValue={chartsSearchInputValue}
                  loading={loading}
                  onClearSearch={onHandleClearSearch}
                />
              }
            </div>
          </div>
        </div>
      </PageLayout>
    </div>
  )
})

export default Charts
